<template lang="pug">
  div.wrap-user
    div(v-if='user').user-content.py60
      div.wrap-profile
        div.f.fc
          div.wrap-user-icon.f.fh.mb8
            img(:src='user.iconURL')
        div.f.fc
          span.name.mr4 {{user.name}}
          v-icon(
            @click='$router.push(`/set_profile/${user.uid}`)'
            size='24px'
            color='#999') create
      div.wrap-certificates.mt12
        div.f.fc
          div(v-for="item in completedCourses").mt8.f.fm
            v-icon(size='24px' color='#4285f4') verified_user
            span {{item.title}}
      //- div(v-if='showCertificate').wrap-certificates.mt12
        div.f.fm
          v-icon(size='24px' color='#4285f4') verified_user
          span {{this.course.title}}
    div.course-header.py2
      div.header-content.f.fh.flex-between
        div.action.left
        span 受講したコース
        div.action.right
          v-icon(
            @click="$router.push('/add_course')"
            color="#1a73e8"
            size="20px") add
    div(v-if="courseList").course-list
      div(
        v-for="item in courseList"
        @click="$router.push(`/course/${item.id}`)").list
        div.list-content.f.fm.flex-between.py8
          span.fz14.my4 {{item.title}}
          v-icon keyboard_arrow_right
          //- div.mb4
            img(:src="item.mainImg")
</template>

<style lang="scss" scoped>
.wrap-user {
  width: 100%;
  min-height: 100vh;
  padding-top: 48px;
  .user-content {
    .wrap-user-icon {
      border-radius: 50%;
      overflow: hidden;
      width: 120px;
      height: 120px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .name {
      font-size: 18px;
    }
  }
  .course-header {
    border-bottom: solid #1a73e8 1px;
    .header-content {
      position: relative;
      max-width: 420px;
      margin: 0 auto;
      span {
        color: #1a73e8;
      }
      .action {
        position: absolute;
      }
      .right {
        right: 14px;
      }
    }
  }
  .course-list {
    .list {
      border-bottom: solid #999 1px;
      .list-content {
        width: 93%;
        max-width: 420px;
        margin: 0 auto;
      }
    }
  }
}
</style>

<script>
import db from '@/components/utils/firebase'
import { createNamespacedHelpers } from 'vuex'
const { mapState: mapStateAuth, mapActions: mapActionsAuth } = createNamespacedHelpers('auth')
import { database } from '@shared/database'

export default {
  components: {
  },
  computed: {
    ...mapStateAuth(['uid'])
  },
  // props: {
  //   user: {
  //     type: Object,
  //     required: true
  //   }
  // },
  data () {
    return {
      user: null,
      showModal: true,
      course: null,
      courseList: null,
      completedCourses: [],
      showCertificate: false
    }
  },
  async created () {
    // this.user = await db.collection('USERS')
    //   .doc(this.uid)
    //   .get()
    //   .then(d => {
    //     var data = d.data()
    //     data.uid = d.id
    //     return data
    //   })
    this.user = await database.getTrainee(this.uid)

    var promises = this.user.plans.map(planId =>{
      // return db.collection('COURSES')
      //   .doc(planId)
      //   .get()
      //   .then(d => {
      //     var data = d.data()
      //     data.id = d.id
      //     return data
      //   })
      return database.getCourse(planId)
    })
    this.courseList = await Promise.all(promises)

    // this.course = await db.collection('COURSES')
    //   .doc('digital_learning')
    //   .get()
    //   .then(d => {
    //     var data = d.data()
    //     data.id = d.id
    //     return data
    //   })
    
    // this.reports = await db.collection('REPORTS')
    //   .where('createdBy', '==', this.uid)
    //   .where('course', '==', 'digital_learning')
    //   .get()
    //   .then(q => {
    //     return q.docs.map(d => {
    //       return d.data()
    //     })
    //   })
    
    // if (this.course.lectures.length >= this.reports.length + 1) {
    //   var passedReports = this.reports.filter(e => { return e.status === 'pass' })
    //   if (passedReports.length === this.course.lectures.length - 1) this.showCertificate = true
    // }

    for (var i = 0; i < this.courseList.length; i++) {
      this.hasCertificate(this.courseList[i])
    }
  },
  methods: {
    ...mapActionsAuth(['signOut']),
    onLoggedIn () {
      
    },
    onFailedAuthentication () {
      this.$router.push('/sign-in')
    },
    async hasCertificate (course) {
      // var reports = await db.collection('REPORTS')
      // .where('createdBy', '==', this.uid)
      // .where('course', '==', course.id)
      // .get()
      // .then(q => {
      //   return q.docs.map(d => {
      //     return d.data()
      //   })
      // })
      var reports = await database.getReportsByOptions({
        createdBy: this.uid,
        course: course.id
      })
      var lecturesWithReport = course.lectures.filter(e => { return e.report })
      var passedReports = reports.filter(e => { return e.status === 'pass' })
      if (passedReports.length === lecturesWithReport.length) {
        this.completedCourses.push(course)
        // this.courseList.map(e => {
        //   if (course.id === e.id) e.completed = true
        //   return e
        // })
      }
    }
  }
}
</script>
